import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import Flex from "../../../../components/Flex/Flex";
import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";
import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";

import useAgreementTemplatesQuery from "../../hooks/useAgreementTemplatesQuery";

import useAgreementTemplatesTableColumns from "./hooks/useAgreementTemplatesTableColumns";

export default function AgreementTemplatesView({ firstPartyId }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const query = useAgreementTemplatesQuery({ firstPartyId });
	const columns = useAgreementTemplatesTableColumns();

	return (
		<>
			<Flex gap={10} wrap style={{ marginBottom: 15 }}>
				<div>
					<Header as="h2">{t("agreementTemplates", "Agreement templates")}</Header>
				</div>

				<div style={{ whiteSpace: "nowrap" }}>
					<Flex gap={10} justifyContent="flex-start">
						<PrimaryButton as={Link} to="create">
							{t("createAgreementTemplate", "Create agreement template")}
						</PrimaryButton>
					</Flex>
				</div>
			</Flex>

			<CollectionDataTable
				persist
				filterable
				query={query}
				columns={columns}
				onClick={({ id }) => navigate(id)}
				sortable
				sortBy={{
					id: "created",
					desc: true,
				}}
			/>
		</>
	);
}
